<template>
  

  <div class="row">
    <div class="col-12 mb-3">
      <!--router-view name="filter"></router-view-->
      <router-view name="map"></router-view>
      <router-view name="table"></router-view>
      <router-view name="form"></router-view>
    </div>
  </div>
</template>

<script>
  import { useRouter } from 'vue-router'
  
  export default {
    components: {

    },
    data() {
      
    },
    setup() {
      const router = useRouter()

      return {
        router
      }
    },
    methods : {
    }
  }
</script>

<style>
</style>